
  import { Component, OnInit, ElementRef, ViewChild, Renderer2 } from '@angular/core';
  import { ExcelService } from '../common/API/excel.service';
  import { Router, ActivatedRoute } from '@angular/router';
  // import { ApiService } from '../../Common/API/api.service';
  import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
  import * as XLSX from 'ts-xlsx';
  import { NotifierService } from 'angular-notifier';
  import { WorkBook } from 'xlsx';
  import * as $ from 'jquery';
  import { NgxSpinnerService } from 'ngx-spinner';
  import { BackRestrict } from '../common/backRestrict'
  import { CommonService } from '../Services/common.service';
  import { ApiService } from '../common/API/api.service';
  import { MatPaginator, MatSort, MatTableDataSource, ErrorStateMatcher } from '@angular/material';
  import { filter } from 'rxjs-compat/operator/filter';
  import { fillProperties } from '@angular/core/src/util/property';
 // import {DeviceLocationModel } from '../Models/DeviceLocationData';
  import { DatePipe } from '@angular/common';
  import { DeviceModel, DeviceCategory } from '../Models/DeviceData';


  
  declare var config;
  
  @Component({
    selector: 'app-upload-EANGTIN_Mapping',
    templateUrl: './upload-EANGTIN_Mapping.component.html',
    styleUrls: ['./upload-EANGTIN_Mapping.component.css']
  })
  export class UploadEANGTIN_MappingComponent implements OnInit {
    @ViewChild('fileUpload') fileUpload: ElementRef;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('openBankModel') openBankModel: ElementRef;
    @ViewChild('skuid') skuid: any;
    @ViewChild('DeviceModels') DeviceModels: any;
    
    public IsOverridePhoneModel: false;
    displayedColumns: string[] = ['StoreName', 'StoreAddress', 'zipcode', 'City', 'UserName','storepassword'];

  
    public Enterprisedata = [];
    Enterpriselist: any;
    public dataTableID: any = false;
    //EnterprisePartnerlist: any;
    public selectedDeviceVendorInPage: any;
    public data = [];
    RetailStores: any;
    searchdata:any;
    public dataSource: any;
    public arrayBuffer: any;
    public excelSheetData: any[];
    public uploadresponse:any[];
    public ExcelSheet: any;
    public status:any;
    public readonly notifier: NotifierService;
    userinfo: any;
    ChoosefileName: any;
    public EnterprisePartnerID: any;
    public EnterpriseID: any;
    public CurrencyName: any;
    public showexcelSheetData = [];
    public SuccessfullyUplodedList = [];
    public UnSuccessfullyUplodedList = [];
    public WarningUplodedList = [];
    public displayedColumnsMobilePhones = ['SKUID', 'EAN_GTINId', 'Response'];
   // public devicelocation: DeviceLocationModel[] = [];
    AllList: [];
    public onSuccess: boolean;
    public successData: boolean;
    public LogFound: boolean = false;
    public Alldata = [];
    form: FormGroup;
    logform: FormGroup;
    ENGTIN:FormGroup;
    excelData: any;
    empty:any;
    ExcelFilterData = [];
    unsuccessdata = [];
    FailLogs: boolean;
    WarningLogs:boolean;
    public disabledexportBtn: boolean = true;
    FailModal: boolean;
    WarningModals:boolean;
    Successmodal: boolean;
    //Data based on category
    OriginalDeviceData: any;
    DeviceCategory: any;
    DeviceCategoryID: any;
    vendorKeyword = 'DeviceModelFullName';
    SKUKeyword = 'SKUID';
    
    private matdatasource: any;

    public StoreName: any;
    public StoreAddress: any;
    public ZipCode: any;
    public City: any;
    public StorePassword: any;


    public Color: any;
    public SKU: any;
    selectedSKUIID: any;
    selectedModel: string;
    RetailStoress: any;
    skuresponse:any = [];
    skuerror: boolean = false;
    modelerror: boolean =  false;
    errorMassageforsku: string;
    errorMassageformodel: string;
    ngSKUID: string;
    ngDeviceModelFullName: string;


  
    constructor(private _service: CommonService, private router: Router,
      private excelService: ExcelService, private formbuilder: FormBuilder, notifierService: NotifierService
      , private spinner: NgxSpinnerService, private backrestrict: BackRestrict, private renderer: Renderer2, private _apiService: ApiService) {
     
  
      this.logform = formbuilder.group({
        StoreName: [null],
        StoreAddress: [null],
        ZipCode: [null],
        City: [null],
        StorePassword: [null],
      
      });

      this.ENGTIN = formbuilder.group({
        selectedModel: [null],
        selectedSKUIID: [null],
       
      
      });
      
      this.notifier = notifierService;
    }
    public pageSizeOptions = [5, 10, 15, 20];
  public pageSize = 10;
  public length = 10;
    ngOnInit() {
      debugger
      this.excelSheetData = [];
      this.ExcelFilterData = [];
      this.unsuccessdata = [];
      this.uploadresponse = [];
      this.UnSuccessfullyUplodedList = [];
      this.WarningUplodedList= [];
      this.SuccessfullyUplodedList =[];
      this.backrestrict.clearBrowserBackHistory();
      this.onSuccess = false;
      this.userinfo = JSON.parse(sessionStorage.getItem('userinfo'));
      this.EnterprisePartnerID = 0;
      this.DeviceCategoryID = 1;
      this.EnterpriseID = config.EnterpriseID;
      this.CurrencyName = "US Dollar";
      this.ChoosefileName = "Choose file";
    
      this.GetModelDetail();
     // this.GetRetailStoreList();
     // this.GetModelDetails();
    }
  

    onFileChanged(event) {
      debugger
      this.onSuccess = false;
      this.unsuccessdata = [];
      this.excelSheetData = [];
      this.ExcelFilterData = [];
    
        if (event.target.files[0] != undefined && event.target.files[0].name.split('.').pop() === 'xlsx') {
          this.spinner.show();
          this.ChoosefileName = event.target.files[0].name;
          this.ExcelSheet = event.target.files[0];
          this.getExcelFile();
        }
        else {
          this.notifier.notify('error', 'Please choose excel file');
          this.fileUpload.nativeElement.value = '';
          this.ChoosefileName = "Choose file";
        }
      }
      getExcelFile() {
        debugger
        
        let fileReader = new FileReader();
        fileReader.onload = (e) => {
          this.arrayBuffer = fileReader.result;
          var data = new Uint8Array(this.arrayBuffer);
          var arr = new Array();
          for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
          var bstr = arr.join('');
          let workbook: WorkBook = XLSX.read(bstr, { type: 'binary' });
          var first_sheet_name = workbook.SheetNames[0];
          var worksheet = workbook.Sheets[first_sheet_name];
          var excel_data = XLSX.utils.sheet_to_json(worksheet, { raw: false });
          this.excelSheetData = [];
          excel_data.forEach(current_value => {
               var randomstring = Math.random().toString(36).slice(-8);
            const uploadEANGTIN_Mapping = {

              
             // DeviceModelFullName:  this.selectedModel,
              // this.ENGTIN.value.selectedModel,
              EAN_GTINId :current_value['EAN_GTINId'],
              SKUID : current_value['SKUID']
              //this.selectedSKUIID,
              // this.ENGTIN.value.selectedSKUIID,
         
              
            };
            this.excelSheetData.push(uploadEANGTIN_Mapping);
          });
    
          this.excelData = this.excelSheetData;
          debugger
       
           if ( excel_data.length < 1 || this.excelData[0].EAN_GTINId === undefined || this.excelData[0].EAN_GTINId === '') {
            this.fileUpload.nativeElement.value = '';
             this.notifier.notify('error', 'Excel is not in proper format');
             this.excelSheetData = [];
             this.excelData =[];
             this.ExcelSheet=[];
             this.clearFiledta()
             
           }
           this.spinner.hide();
         
        
        }
        if ($('#reading_txt').val(this.ExcelSheet.name) === '') {
    
          $('#reading_txt').val(this.ExcelSheet.name);
        }
        fileReader.readAsArrayBuffer(this.ExcelSheet);
      }
    




      Upload() {
        debugger
        // if(this.selectedSKUIID == '' || this.selectedSKUIID == undefined)
        // {
          
        //   this.errorMassageforsku = 'Select SKUID'
        //   this.skuerror = true;

        // }
        // else if( this.selectedModel == '' || this.selectedModel == undefined )
        // {
        //   this.errorMassageformodel = 'Select DeviceModel first';
        //   this.modelerror = true;
         
        // }
    //    else{
        this.spinner.show();
        this.FailLogs = false;
        this.WarningLogs = false;
        
        this.onSuccess = false;
        this.successData = false;
        var _ValidData = this.excelData
        this.UnSuccessfullyUplodedList = [];
        this.WarningUplodedList= [];
        this.SuccessfullyUplodedList =[];
        debugger
        this.Alldata = this.excelSheetData.map(element => {
          return {
            EAN_GTINId :element.EAN_GTINId === undefined ? '': element.EAN_GTINId ,
          //  SKUID :this.selectedSKUIID === undefined ? '': this.selectedSKUIID,
            SKUID:element.SKUID  === undefined ? '' :element.SKUID , 
            // DeviceModelFullName:element.DeviceModelFullName=== undefined?'' :element.DeviceModelFullName

          };
        });
      
        if (this.excelData != null && this.excelData.length > 0) {
          debugger
          this._service.PostPartner(this.Alldata , 'api/UploadEANGTIN_Mapping').then((result: any) => {
            debugger
            this.clearFiledta();
            if (result !== null && result.length > 0 && result[0].Response) {
              debugger
          
              this.uploadresponse=result;
              this.onSuccess = true;
            
              var SuccessResponse = this.uploadresponse.filter(x => x.Response == 'Success:-EANGTIN Uploaded Successfully');
              if (SuccessResponse.length > 0) {
                this.SuccessfullyUplodedList.push(SuccessResponse);
                      this.successData = true;
                    }
                    var WarningResponse = this.uploadresponse.filter(x => x.Response == 'Warning:-EANGTIN is already mapped.');
                    if (WarningResponse.length > 0) {
                      this.WarningUplodedList.push(WarningResponse);
                      this.WarningLogs = true;
                    }
                    var ErrorResponse = this.uploadresponse.filter(x => x.Response == ('Error:-EANGTIN is Invalid.') || x.Response ==( 'Error:-SKUID is Invalid.' ));
                  
                    if (ErrorResponse.length > 0) {
                      this.UnSuccessfullyUplodedList.push(ErrorResponse);
                      this.FailLogs = true;
                    }
        
              

              result.forEach(element => {
                if(element.Response.includes('Success'))
                {                  
                  this.successData = true;                
                }
                // else if(element.Response.includes('Warning'))
                // {
                //   this.status = 'logs';                  
                // }
                // else if(element.Response.includes('EANGTIN is Invalid')) 
                // {
                //   this.status = 'Existing';
                  
                // }
                // else if(element.Response.includes('SKUID is Invalid'))
                // {
                //   this.status = 'empty';
            
                // }

                else{                 
                  this.successData = false;
                }
              });
           
            if(this.successData == true)
            {
              this.spinner.hide();
              this.notifier.notify('success', 'GTIN uploaded successfully');
            }
            // else if(this.status == 'logs')
            // {
            //   this.spinner.hide();
            //   this.notifier.notify('warning', 'EANGTIN ID  already mapped');

            // }
            // else if(this.status == 'Existing')
            // {
            //   this.spinner.hide();
            //   this.notifier.notify('warning', 'Error:-EANGTIN is Invalid.');
            // }
            // else if(this.status == 'empty')
            // {
            //   this.spinner.hide();
            //   this.notifier.notify('warning', 'SKUID is Invalid');
            // }
            else if(this.successData == false)
            {
              this.spinner.hide();
              this.notifier.notify('warning', 'GTIN uploaded with some failed Logs');

            }
            else {
                this.onSuccess = false;
                this.spinner.hide();
                this.notifier.notify('error', 'GTINId data not uploaded');
              }
              // this.GetModelDetail();
         
            }
            else {
              this.clearFiledta();
              //  console.log(result);
              this.spinner.hide();
              this.notifier.notify('error', 'Something went wrong');
            }
           
          },
            error => {
              this.spinner.hide();
              console.log(error);
              this.clearFiledta();
              this.notifier.notify('error', 'An error occured');
            });
        }
        else {
          this.spinner.hide();
          this.clearFiledta();
          this.onSuccess = true;
          this.FailLogs = true;
          this.notifier.notify('warning', 'GTIN Data  not uploaded with some fail Logs');
        }
    //  }
      }

      clearFiledta() {
        this.excelSheetData = [];
        this.fileUpload.nativeElement.value = '';
        this.ChoosefileName = "Choose file";
      }
    
      Clear() {
        this.excelSheetData = [];
        this.uploadresponse=[];
        this.fileUpload.nativeElement.value = '';
        this.onSuccess = false;
        this.FailLogs=false;
        this.WarningLogs=false;
        this.ChoosefileName = "Choose file";
        this.EnterprisePartnerID = 0;
        this.DeviceCategoryID = 1;
        this.disabledexportBtn = true;
        this.selectedDeviceVendorInPage='';
        this.selectedSKUIID ='';
        this.selectedModel= '';
        this.skuerror = false;
        this.modelerror= false;
        this.skuid.searchInput.nativeElement.value  =''
        this.DeviceModels.searchInput.nativeElement.value  =''
        this.searchdata ='';
        this.ngSKUID = '';
        this.ngDeviceModelFullName='';
        this.RetailStoress='';
       
  this.RetailStoress = this.RetailStores;
  
        
      }





 ShowLogs()
{
  if(this.uploadresponse.length!=0)
  {
    this.LogFound=true;
  }
  let el: HTMLElement = this.openBankModel.nativeElement as HTMLElement;
  el.click();


}
GetRetailStoreList() {
  

  
  this.spinner.show();
  this.matdatasource = new MatTableDataSource([]);
  this._apiService.get(config.WebApiPath + 'api/support-tool/GetStoresInfo').subscribe(result => {
    
    console.log(result);
    if (result.Data.length > 0) {
      this.RetailStoress = result.Data;
      this.matdatasource = this.RetailStoress;
      this.dataSource = new MatTableDataSource(this.RetailStoress);
      setTimeout(() => { this.dataSource.paginator = this.paginator; this.dataSource.sort = this.sort }, 100);
   // this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.spinner.hide();
    }
    else {
      this.spinner.hide();
    }
  },
    error => {
      console.log(error);
      this.spinner.hide();
    }
  );
}
selectVendorData(event,type) {
  debugger
  if(type == 'model')
  {
    this.skuid.searchInput.nativeElement.value = event.SKUID;
    this.selectedModel= event.DeviceModelFullName;
    this.selectedSKUIID = event.SKUID;
    this.RetailStoress = this.RetailStores.filter(x => x.DeviceModelFullName == event.DeviceModelFullName);
    this.dataSource = new MatTableDataSource(this.RetailStoress);
  }
  else{
   // let sku = parseInt(event.SKUID);
    this.selectedSKUIID = event.SKUID;
    this.selectedModel= event.DeviceModelFullName;
    this.DeviceModels.searchInput.nativeElement.value = event.DeviceModelFullName
    this.RetailStoress = this.RetailStores.filter(x => x.SKUID == event.SKUID);
  this.dataSource = new MatTableDataSource(this.RetailStoress);
  }
  this.skuerror = false;
  this.modelerror = false;
  
}
    
selectSKUData(event) {
  debugger
  
  this.searchdata = this.RetailStores.filter(x => x.SKUID == event.SKUID).toLocaleLowerCase();
  this.dataSource = new MatTableDataSource(this.searchdata);
}

closeDeviceList(type) {
  debugger
  this.skuid.searchInput.nativeElement.value  =''
        this.DeviceModels.searchInput.nativeElement.value  =''
   this.selectedSKUIID = '';

this.selectedModel = '';
  
  this.ngSKUID = '';
  this.ngDeviceModelFullName='';
  this.searchdata ='';
  // this.GetRetailStoreList();
  this.RetailStoress = this.RetailStores;
  
}

GetModelDetail() {
    debugger
    this.spinner.show();
    var param = {
    
      DeviceCategoryID:config.DeviceCategoryID,
      EnterprisePartnerID: this.EnterprisePartnerID,
      IsModelOverride: true
    }
    this._service.PostPartner(param, 'api/Pricing/getmodeldetailsforprice').then(  result => {
 // this._apiService.get(config.WebApiPath + 'api/support-tool/get-EANGTIN_Mapping').subscribe(result => {
    
    console.log(result);
    debugger
   
    if (result !== null  && result.length > 0) {
      debugger
      this.spinner.hide();
     
      this.RetailStores = result;
    
      this.RetailStoress = result;
    
      this.matdatasource = this.RetailStoress;
      this.dataSource = new MatTableDataSource(this.RetailStoress);
      this.data = [];
     
    }
    else {
      this.spinner.hide();
    }
  },
    error => {
      console.log(error);
      this.spinner.hide();
    }
  );



}
exportAsXLSX() {
    
  // this.GetModelDetail();
  
   let _ExportGTINDevices = [
          
 

    // { EAN_GTINId:'',DeviceModelFullName :'',SKUID:''
    //  } ];
    { EAN_GTINId:'',
    SKUID:''
      
     } ];
     this.excelService.exportAsExcelFile(_ExportGTINDevices, 'EANGTIN_MappingData');

 }

 successModal() {
    
  this.dataTableID = true;
  this.Successmodal = true;
  this.FailModal = false;
  this.WarningModals = false;
  const strtext = JSON.parse(JSON.stringify(this.SuccessfullyUplodedList[0]));

  this.dataSource = new MatTableDataSource(strtext);

  setTimeout(() => { this.dataSource.paginator = this.paginator; this.dataSource.sort = this.sort }, 100);
}
failModal() {
  debugger
  this.dataTableID = true;
  this.FailModal = true;
  this.Successmodal = false;
  this.WarningModals = false;
  const strtext = JSON.parse(JSON.stringify(this.UnSuccessfullyUplodedList[0]));

  this.dataSource = new MatTableDataSource(strtext);
 
  setTimeout(() => { this.dataSource.paginator = this.paginator; this.dataSource.sort = this.sort }, 100);
}
WarningModal() {
  debugger
  this.dataTableID = true;
  this.FailModal = false;
  this.WarningModals = true;
  this.Successmodal = false;
  const strtext = JSON.parse(JSON.stringify(this.WarningUplodedList[0]));

  this.dataSource = new MatTableDataSource(strtext);

  setTimeout(() => { this.dataSource.paginator = this.paginator; this.dataSource.sort = this.sort }, 100);
}

exportSuccessAsXLSX() {
  this.spinner.show();
  this.excelService.exportAsExcelFile(this.SuccessfullyUplodedList[0], 'SuccessfullyUplodedList');
  this.spinner.hide();
}
exportUnsuccessAsXLSX() {
  this.spinner.show();
  this.excelService.exportAsExcelFile(this.UnSuccessfullyUplodedList[0], 'InvalidUplodedList');
  this.spinner.hide();
}
exportWarningAsXLSX() {
  this.spinner.show();
  this.excelService.exportAsExcelFile(this.WarningUplodedList[0], 'UnSuccessfullyUplodedList');
  this.spinner.hide();
}
// GetModelDetails() {
    
//   var enterprise = this.Enterprisedata.find(x => x.EnterprisePartnerID === Number(this.EnterprisePartnerID));
//   // if (enterprise) {
//   //   this.IsOverridePhoneModel = enterprise.IsModelOverride;
//   // } else {
//   //   this.IsOverridePhoneModel = false;
//   // }
//   this.spinner.show();

//   var param = {
//     EnterprisePartnerID: this.EnterprisePartnerID,
//     DeviceCategoryID:config.DeviceCategoryID,
//     // IsModelOverride: this.IsOverridePhoneModel
//     IsModelOverride: true
//   }
//   this._service.PostPartner(param, 'api/Pricing/getmodeldetailsforprice').then(
//     (result: DeviceModel[]) => {
//       debugger;
//       this.disabledexportBtn=false;
//       if (result !== null && result.length > 0) {
        
//         this.spinner.hide();
//         this.OriginalDeviceData = result;//Original data for showing data in html tables
    
    
     
       
//       }
//       else {
//         this.spinner.hide();
//         console.log('error ');
//       }
//     },
//     error => {
//       this.spinner.hide();
//       console.log(error);
//     }
//   );
// }

    }

  